import { render } from "./sectionc.vue?vue&type=template&id=f2efbce0"
import script from "./sectionc.vue?vue&type=script&lang=js"
export * from "./sectionc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__